import React from 'react';
import classNames from 'classnames';
import { Select, DatePicker, Button } from 'antd';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import styles from '../styles';
import { getFilteringState } from '../reducers';
import { change_popup_details_view_state } from '../actions';

const { Option } = Select;
const RightSidebarContent = ({ ...props }) => {
  const { classes } = props;

  return (
    <div className={classes.rightSidebarDrawerWrapperRoot}>
      <div
        className={classNames({
          [classes.drawerWrapperOpen]: false,
          [classes.drawerWrapperClose]: true
        })}
      >
        <div className={classes.datePicker}>
          <React.Fragment>
            <Select
              style={{ width: 120 }}
              defaultValue={props.defaultFilterType}
              onChange={props.actionOnTypeChange}
            >
              <Option value="monthly">Monthly</Option>
              <Option value="quarterly">Quarterly</Option>
            </Select>
            <div>
              <DatePicker
                style={{ width: 120 }}
                defaultValue={props.defaultDateRange}
                onChange={props.actionOnDateChange}
              />
            </div>
          </React.Fragment>
          <Button
            style={{ background: '#FFCB37' }}
            onClick={() => {
              props.change_popup_details_view_state(true);
            }}
          >
            Details
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  filteringState: getFilteringState(state)
});

const mapDispatchToProps = {
  change_popup_details_view_state
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(RightSidebarContent));
